import { Button, Card, Typography } from "@p0security/ui";
import React from "react";
import { useSearchParams } from "react-router-dom";

import { Splash } from "../Splash";

export const EmailVerified = () => {
  return (
    <LoginActionPage
      title="Email Verified"
      description="Your email has been verified successfully. Click the button below to
sign in."
    />
  );
};

export const PasswordChanged = () => {
  return (
    <LoginActionPage
      title="Password Changed"
      description="Your password has been changed successfully. Click the button below to
sign in."
    />
  );
};

type LoginActionPageProps = {
  title: string;
  description: string;
};

export const LoginActionPage: React.FC<LoginActionPageProps> = (props) => {
  const [searchParams] = useSearchParams();
  const orgSlug = searchParams.get("orgSlug");

  return (
    <LoginActionLayout>
      {orgSlug ? (
        <LoginActionSuccess orgSlug={orgSlug} {...props} />
      ) : (
        <EmailVerifiedFailure />
      )}
    </LoginActionLayout>
  );
};

const LoginActionSuccess: React.FC<
  {
    orgSlug: string;
  } & LoginActionPageProps
> = ({ orgSlug, description, title }) => {
  return (
    <Card title={title}>
      <Typography.Paragraph>{description}</Typography.Paragraph>
      <Button href={`/o/${orgSlug}`} type="primary" className="w-full">
        Sign In
      </Button>
    </Card>
  );
};

export const EmailVerifiedFailure: React.FC = () => {
  return (
    <Card title={"Bad Request"}>
      <Typography.Paragraph>
        Looks like there was a problem with your request (missing parameters).
        Please find your organization and login.
      </Typography.Paragraph>
      <Button href={"/"} type="primary" className="w-full">
        Sign In
      </Button>
    </Card>
  );
};

export const LoginActionLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return <Splash>{children}</Splash>;
};
